// 📁 ProjectOverview.jsx
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { getAuth } from "firebase/auth";
import ProjectDefinition from "./ProjectDefinition";
import ProjectResourcesCard from "../components/projects/ProjectResourcesCard";
import ProjectTasksCard from "../components/projects/ProjectTasksCard";

import { notificationsApi } from "../services/notificationsApi";
import ProjectActivityTimeline from "../components/projects/ProjectActivityTimeline";
import ProjectDashboardCard from "../components/projects/ProjectDashboardCard";
import ProjectWorkloadCard from "../components/projects/ProjectWorkloadCard";

// Lista mogućih koraka (aktivnosti) sa ikonama
const workOptions = [
  { label: "order", icon: "/icons/order.svg" },
  { label: "offer", icon: "/icons/offer.svg" },
  { label: "design", icon: "/icons/design.svg" },
  { label: "documentation", icon: "/icons/documents.svg" },
  { label: "material", icon: "/icons/material.svg" },
  { label: "assembly", icon: "/icons/assembly.svg" },
  { label: "transport", icon: "/icons/transport.svg" },
  { label: "installation", icon: "/icons/install.svg" },
  { label: "dismantling", icon: "/icons/demolition.svg" },
  { label: "wasteRemoval", icon: "/icons/waste.svg" },
];

const ProjectOverview = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { projectId } = useParams();
  

  const isNewProject = projectId === "newProject" || localStorage.getItem("newProject") === "true";

  const [projectName, setProjectName] = useState("");
  const [scope, setScope] = useState([]);




  useEffect(() => {
    const fetchProject = async () => {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user || !projectId || isNewProject) return;

      try {
        const token = await user.getIdToken();
        const res = await axios.get(`https://modularobjects.com/checkout/api/project/${projectId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data) {
          setProjectName(res.data.project_name);
          setScope(res.data.scope || []);
        }
      } catch (err) {
        console.error("Failed to fetch project data:", err);
      }
    };

    fetchProject();
  }, [projectId, isNewProject]);

  // Ako je nov projekat, prikaži formu za definisanje
  if (isNewProject) {
    return <ProjectDefinition />;
  }

  const getTabIcon = (tabId) => {
    const found = workOptions.find((option) => option.label === tabId);
    return found ? found.icon : null;
  };

  const getAvailableTabs = () => {
  const tabs =
    scope.length > 0
      ? workOptions.filter(opt => scope.includes(opt.label)).map(opt => opt.label)
      : workOptions.map(opt => opt.label);

  return [...new Set(["order", ...tabs])];
};


  const handleTabClick = (tabId) => {
    switch (tabId) {
      case "order":
        navigate(`/project/${projectId}/order`);
        break;
      case "design":
        navigate(`/project/${projectId}/design`);
        break;
      case "documentation":
        navigate(`/project/${projectId}/docs`);
        break;
      case "material":
        navigate(`/project/${projectId}/material`);
        break;
      default:
        navigate(`/project/${projectId}/${tabId}`);
        break;
    }
  };

  return (
  <div className="w-full max-w-6xl mx-auto px-4 py-4">
    <h1 className="text-3xl font-bold text-primary-light dark:text-primary-dark mb-6">
      {projectName || t("projectOverview")}
    </h1>
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
      {getAvailableTabs().map((tabId) => {
        const icon = getTabIcon(tabId);
        return (
          <button
            key={tabId}
            onClick={() => handleTabClick(tabId)}
            className="flex flex-col items-center justify-center p-4 border rounded hover:bg-primary-light hover:text-black transition"
          >
            {icon && <img src={icon} alt={tabId} className="w-8 h-8 mb-2" />}
            <span className="font-semibold">{t(tabId)}</span>
          </button>
        );
      })}
    </div>

    <div className="mb-6">
      <ProjectDashboardCard projectId={projectId} />
    </div>
    <div className="mb-6">
      <ProjectWorkloadCard projectId={projectId} />
    </div>
    <div className="mb-6">
      <ProjectResourcesCard projectId={projectId} />
    </div>
    <div className="mb-6">
      <ProjectTasksCard projectId={projectId} />
    </div>
    <div className="mb-6">
      <ProjectActivityTimeline projectId={projectId} />
    </div>
  </div>
);
};

export default ProjectOverview;
